export const isValidZipcode = (zip: string) => /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(zip);
